module.exports = __webpack_public_path__ + "img/img4.c91cb548.jpg";